import { render, staticRenderFns } from "./QQuestion.vue?vue&type=template&id=5652e2d5&scoped=true"
import script from "./QQuestion.vue?vue&type=script&lang=js"
export * from "./QQuestion.vue?vue&type=script&lang=js"
import style0 from "./QQuestion.vue?vue&type=style&index=0&id=5652e2d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652e2d5",
  null
  
)

export default component.exports